import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/Interior/ai-theta.jpg";
import image from "../../assets/product-list-assets/cameras/interior-design/ai-theta.jpg";
import { type Product } from "../../types";
import { interiorDesign } from "../product-groups/cameraSecurity/InteriorDesign";
import { interiorDesign as productListGroupInteriorDesign } from "../product-list-groups/interiorDesign";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const aiTheta: Product = {
  id: "theta",
  productTitle: "AI Theta",
  techspecsPath: [SiteId.TechSpecs, "/unifi/cameras-nvrs/uvc-ai-theta"],
  storePathParts: { productSlug: "uvc-ai-theta", category: "cameras-theta" },
  sku: "UVC-AI-Theta",
  description: "theta.description",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 250,
    height: 182,
  },
  productGroup: interiorDesign,
  productListGroup: productListGroupInteriorDesign,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          "UVC-AI-Theta-Hub:\n140 x 70 x 38 mm\n(5.5 x 2.8 x 1.5”)\n\n\nUVC-AI-Theta-Lens/360:\nØ22.8. x 43.5 mm\n(Ø0.9 x 1.7”)",
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: {
        type: "string",
        value:
          "UVC-AI-Theta-Lens:\n8MP CMOS\nUVC-AI-Theta-Lens-360:\n12MP CMOS",
      },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "theta.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "translation", value: "theta.faceRecognition" },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: {
        type: "translation",
        value: "theta.licensePlateRecognition",
      },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "translation", value: "theta.aiRecognition" },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "theta.cameraAudio",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
